import React from "react";

export function LampIcon(props) {
    return <svg className={'multi-color'}
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 474.363 474.363"
                id={"lamp"}
    >
        <path className={"switch"} d="M301.721,436.861h-57.51V402.47c0-6.408,5.194-11.602,11.602-11.602h34.305
                c6.408,0,11.602,5.195,11.602,11.602v34.391H301.721z"/>
        <circle className="bulb-part-1" cx="120.64" cy="191.25" r="48.85"/>
        <path className="bulb-part-2" d="M137.239,237.203c18.807-6.795,32.251-24.802,32.251-45.952
                c0-26.979-21.871-48.85-48.85-48.85c-21.151,0-39.157,13.444-45.952,32.251C95.538,195.502,116.389,216.352,137.239,237.203z"/>
        <circle className="dome" cx="263.105" cy="48.85" r="48.85"/>
        <path className="arm" d="M379.191,454.005l-38.907-9.284l41.87-175.463L252.686,141.371l28.11-28.457
                l137.48,135.801c4.975,4.914,7.021,12.07,5.398,18.871L379.191,454.005z"/>
        <path className="base" d="M404.221,474.363H226.244c-13.807,0-25-11.193-25-25s11.193-25,25-25h177.977
                c13.807,0,25,11.193,25,25S418.028,474.363,404.221,474.363z"/>
        <path className="cone" d="M292.544,78.524l-59.349-59.348c-5.917-5.918-13.786-9.177-22.154-9.177
                c-8.369,0-16.237,3.259-22.155,9.177l-39.231,39.231L69.707,73.592c-11.02,2.094-19.917,10.054-23.219,20.773
                c-3.302,10.72-0.426,22.306,7.505,30.238l133.123,133.123c5.703,5.703,13.285,8.843,21.351,8.844h0.001
                c3.014,0,6.004-0.451,8.887-1.338c10.721-3.302,18.681-12.2,20.774-23.22l15.185-79.948l39.231-39.23
                c5.918-5.918,9.177-13.786,9.177-22.155C301.721,92.31,298.462,84.441,292.544,78.524z"/>
        <path className="cone-shade" d="M238.127,242.012l15.185-79.948l39.231-39.231
                c5.918-5.917,9.177-13.786,9.177-22.155s-3.259-16.237-9.177-22.155L262.87,48.85L120.555,191.165l66.562,66.562
                c5.703,5.703,13.285,8.843,21.351,8.844l0,0c3.014,0,6.004-0.451,8.887-1.338C228.075,261.93,236.035,253.032,238.127,242.012z"/>
    </svg>;
}
